import { render, staticRenderFns } from "./AudioSegment.vue?vue&type=template&id=04f41df5&scoped=true"
import script from "./AudioSegment.vue?vue&type=script&lang=js"
export * from "./AudioSegment.vue?vue&type=script&lang=js"
import style0 from "./AudioSegment.vue?vue&type=style&index=0&id=04f41df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f41df5",
  null
  
)

export default component.exports